// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif !important;
  box-sizing: border-box;
}

/* Темная тема (по умолчанию) */
body.st-theme-dark .st-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

/* Светлая тема */
body.st-theme-light .st-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: relative;
}

body.st-theme-light .st-title-icon {
   color: #002FA7;
}

body.st-theme-light .st-content-title {
   color: #002FA7;
}

body.st-theme-light .st-content-subtitle {
   color: #002FA7;
}

.st-content {
  position: relative;
  z-index: 1;
  padding: 20px;
  width: 100%;
  max-width: 1400px;
  margin: auto;
  background: transparent;
}

/* Основной контент */
.st-main {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  width: 100%;
  margin-top: 20px;
  transition: grid-template-columns 0.3s ease;
}

.st-main.sidebar-collapsed {
  grid-template-columns: 80px 1fr;
}

/* Боковая панель */
.st-sidebar {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 600px;
  position: relative;
  transition: all 0.3s ease;
}

.st-sidebar.collapsed {
  width: 80px;
  padding: 24px 16px;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 600px;
  z-index: 2;
}

.st-sidebar.collapsed .st-sidebar-header,
.st-sidebar.collapsed .st-nav-text,
.st-sidebar.collapsed .st-sidebar-footer,
.st-sidebar.collapsed .st-nav-indicator {
  display: none;
}

.st-sidebar.collapsed .st-sidebar-nav {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  width: 100%;
  margin-top: 40px;
}

.st-sidebar.collapsed .st-nav-item {
  width: 52px;
  height: 52px;
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  display: flex;
  position: relative;
}

.st-sidebar.collapsed .st-nav-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.st-sidebar.collapsed .st-nav-svg-icon {
  width: 24px;
  height: 24px;
}

.st-sidebar.collapsed .st-nav-item::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateX(-80%);
  background: #002fa7c2;
  color: white;
  margin-top: 25px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 3;
  margin-left: 10px;
  pointer-events: none;
}

.st-sidebar.collapsed .st-nav-item:hover::after {
  opacity: 1;
}

/* Кнопка сворачивания */
.st-sidebar-toggle {
  position: absolute;
  top: 16px;
  right: -12px;
  width: 24px;
  height: 24px;
  background: #002FA7;
  border: 2px solid white;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 2;
}

.st-sidebar-toggle:hover {
  background: #5986f7;
  transform: scale(1.1);
}

.st-sidebar.collapsed .st-sidebar-toggle {
  transform: rotate(360deg);
}

/* Контент боковой панели */
.st-sidebar-header {
  text-align: center;
}

.st-user-info .st-user-name {
  color: #002fa7;
  font-size: 18px;
  font-weight: 600;
  margin: 4px 0;
}

.st-user-patronymic {
  color: #002fa7;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.st-user-info .st-user-role {
  color: #235bea;
  font-size: 14px;
  font-weight: 500;
  margin: 18px 0 24px 0;
}

.st-user-group,
.st-user-info .st-user-speciality,
.st-user-info .st-user-curator {
  color: #002fa7;
  font-size: 12px;
  font-weight: 400;
  margin: 12px 0;
}

.st-user-info .st-user-group strong{
  color: #002fa7;
  font-size: 12px;
  font-weight: 400;
  margin: 12px 0;
}

.st-user-info .st-user-speciality strong{
  color: #002fa7;
  font-size: 12px;
  font-weight: 400;
  margin: 12px 0;
}

.st-user-info .st-user-curator strong{
  color: #002fa7;
  font-size: 12px;
  font-weight: 400;
  margin: 12px 0;
}

/* Навигация */
.st-sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.st-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.st-nav-item:hover {
  background: rgba(45, 74, 204, 0.1);
}

.st-nav-item.active {
  background: rgba(102, 126, 234, 0.15);
  font-weight: 600;
}

.st-nav-text {
  font-size: 14px;
  color: #002fa7;
}

.st-nav-indicator {
  width: 3px;
  height: 24px;
  background: #002fa7;
  border-radius: 2px;
  position: absolute;
  right: -24px;
}

/* Иконки */
.st-nav-svg-icon {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}

.st-nav-svg-white-icon {
  width: 36px;
  height: 36px;
  margin: 6px 6px 0 4px;
}

.st-nav-toggle-icon {
  width: 22px;
  height: 22px;
  z-index: 1;
}

/* Футер */
.st-sidebar-footer {
  margin-top: 6px;
}

.st-quick-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  background: rgba(102, 126, 234, 0.1);
  padding: 16px;
  border-radius: 12px;
}

.st-stat-item {
  text-align: center;
  margin: 0;
}

.st-stat-item .st-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #002fa7;
  margin: 0;
}

.st-stat-item .st-stat-label {
  font-size: 11px;
  color: #002fa7;
  margin: 8px 0 0 0;
}

/* Основная область контента */
.st-content-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  z-index: 3;
  position: relative;
}

.st-content-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  flex-wrap: nowrap;
  min-width: 0;
  gap: 12px;
}

.st-content-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  min-width: 0;
  flex-shrink: 0;
}

.st-title-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.st-content-title {
  color: white;
  font-size: 26px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 0;
}

.st-content-subtitle {
  color: white;
  font-weight: 200;
  font-size: 14px;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

/* Альтернативный вариант без разделительной линии */
.st-content-subtitle.without-border {
  border-left: none;
  padding-left: 0;
  margin-left: 8px;
}

.st-content-card {
  background: white;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  min-height: 550px;
  width: 100%;
  z-index: 1;
  position: relative;
}

/* Анимированный фон */
.st-background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.st-shape {
  position: absolute;
  opacity: 0.1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: st-float 20s infinite linear;
}

.st-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }
.st-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }
.st-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }

@keyframes st-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(90deg); }
  50% { transform: translateY(0) rotate(180deg); }
  75% { transform: translateY(20px) rotate(270deg); }
}

/* Адаптивность */
@media (max-width: 1200px) {
  .st-content {
    max-width: 95vw;
    padding: 16px;
  }
}

@media (max-width: 1024px) {
  .st-main {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .st-main.sidebar-collapsed {
    grid-template-columns: 1fr;
  }
  
  .st-sidebar {
    order: 2;
    min-height: auto;
  }
  
  .st-sidebar.collapsed {
    width: 100%;
    padding: 20px;
    flex-direction: row;
  }
  
  .st-sidebar.collapsed .st-sidebar-nav {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
  }
  
  .st-sidebar.collapsed .st-nav-item {
    width: 60px;
    height: 60px;
  }
  
  .st-content-area {
    order: 1;
  }
  
  .st-nav-indicator,
  .st-sidebar-toggle {
    display: none;
  }
}

@media (max-width: 768px) {
  .st-content {
    padding: 12px;
  }
  
  .st-content-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    flex-wrap: wrap;
  }
  
  .st-content-title {
    font-size: 22px;
    white-space: normal;
  }
  
  .st-content-subtitle {
    margin-left: 0;
    font-size: 13px;
    white-space: normal;
  }
  
  .st-content-card {
    padding: 16px;
    min-height: 500px;
  }
  
  .st-quick-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .st-sidebar.collapsed {
    padding: 16px;
  }
  
  .st-sidebar.collapsed .st-nav-item {
    width: 50px;
    height: 50px;
  }
  
  .st-nav-svg-icon {
    width: 22px;
    height: 22px;
  }
  
  .st-nav-svg-white-icon {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 480px) {
  .st-content {
    padding: 8px;
  }
  
  .st-main {
    gap: 16px;
    margin-top: 16px;
  }
  
  .st-sidebar {
    padding: 16px;
    border-radius: 16px;
  }
  
  .st-content-card {
    padding: 12px;
    border-radius: 16px;
    min-height: 450px;
  }
  
  .st-user-info .st-user-name,
  .st-user-patronymic {
    font-size: 16px;
  }
  
  .st-content-title {
    font-size: 20px;
    gap: 8px;
  }
  
  .st-sidebar.collapsed .st-nav-item {
    width: 44px;
    height: 44px;
  }
  
  .st-nav-svg-icon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 360px) {
  .st-sidebar.collapsed .st-nav-item {
    width: 40px;
    height: 40px;
  }
  
  .st-nav-svg-icon {
    width: 18px;
    height: 18px;
  }
  
  .st-content-title {
    font-size: 18px;
  }
  
  .st-content-subtitle {
    font-size: 12px;
  }
}


/* Стили для индикатора загрузки */
.st-loading-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 14px;
}

.st-loading-indicator::before {
  content: '';
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.st-content-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Стили для иконки переключения */
.st-nav-toggle-icon.rotated {
  transform: rotate(180deg);
}

/* Улучшенные стили для информации о пользователе */
.st-user-info p {
  margin: 4px 0;
  line-height: 1.4;
}

.st-user-speciality,
.st-user-profile,
.st-user-education,
.st-user-course,
.st-user-curator {
  font-size: 12px;
  color: #64748b;
}

.st-user-speciality strong,
.st-user-profile strong,
.st-user-education strong,
.st-user-course strong,
.st-user-curator strong {
  color: #374151;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Стили для иконок заголовка */
.st-title-icon {
  width: 36px;
  height: 36px;
  margin-left: 4px;
  margin-right: 4px;
  filter: brightness(1);
}

.st-theme-dark .st-title-icon {
  filter: brightness(0) invert(1);
}

.st-theme-light .st-title-icon {
  filter: none;
}

.st-content-title-wrapper .st-title-icon {
  width: 36px;
  height: 36px;
}

.st-theme-dark .st-content-title-wrapper .st-title-icon {
  filter: brightness(0) invert(1);
}

.st-theme-light .st-content-title-wrapper .st-title-icon {
  filter: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentStyle.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,cAAc,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE;AAChE,cAAc,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,UAAU,EAAE,oBAAoB,EAAE;AACvF,cAAc,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAE1F;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,0CAA0C,EAAE;EAClD,MAAM,uCAAuC,EAAE;EAC/C,MAAM,0CAA0C,EAAE;AACpD;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;EAKE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n  box-sizing: border-box;\n}\n\n/* Темная тема (по умолчанию) */\nbody.st-theme-dark .st-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n/* Светлая тема */\nbody.st-theme-light .st-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: relative;\n}\n\nbody.st-theme-light .st-title-icon {\n   color: #002FA7;\n}\n\nbody.st-theme-light .st-content-title {\n   color: #002FA7;\n}\n\nbody.st-theme-light .st-content-subtitle {\n   color: #002FA7;\n}\n\n.st-content {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 100%;\n  max-width: 1400px;\n  margin: auto;\n  background: transparent;\n}\n\n/* Основной контент */\n.st-main {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  width: 100%;\n  margin-top: 20px;\n  transition: grid-template-columns 0.3s ease;\n}\n\n.st-main.sidebar-collapsed {\n  grid-template-columns: 80px 1fr;\n}\n\n/* Боковая панель */\n.st-sidebar {\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.st-sidebar.collapsed {\n  width: 80px;\n  padding: 24px 16px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 600px;\n  z-index: 2;\n}\n\n.st-sidebar.collapsed .st-sidebar-header,\n.st-sidebar.collapsed .st-nav-text,\n.st-sidebar.collapsed .st-sidebar-footer,\n.st-sidebar.collapsed .st-nav-indicator {\n  display: none;\n}\n\n.st-sidebar.collapsed .st-sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  margin-top: 40px;\n}\n\n.st-sidebar.collapsed .st-nav-item {\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n  display: flex;\n  position: relative;\n}\n\n.st-sidebar.collapsed .st-nav-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.st-sidebar.collapsed .st-nav-svg-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.st-sidebar.collapsed .st-nav-item::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateX(-80%);\n  background: #002fa7c2;\n  color: white;\n  margin-top: 25px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: 3;\n  margin-left: 10px;\n  pointer-events: none;\n}\n\n.st-sidebar.collapsed .st-nav-item:hover::after {\n  opacity: 1;\n}\n\n/* Кнопка сворачивания */\n.st-sidebar-toggle {\n  position: absolute;\n  top: 16px;\n  right: -12px;\n  width: 24px;\n  height: 24px;\n  background: #002FA7;\n  border: 2px solid white;\n  border-radius: 50%;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.st-sidebar-toggle:hover {\n  background: #5986f7;\n  transform: scale(1.1);\n}\n\n.st-sidebar.collapsed .st-sidebar-toggle {\n  transform: rotate(360deg);\n}\n\n/* Контент боковой панели */\n.st-sidebar-header {\n  text-align: center;\n}\n\n.st-user-info .st-user-name {\n  color: #002fa7;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 4px 0;\n}\n\n.st-user-patronymic {\n  color: #002fa7;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n}\n\n.st-user-info .st-user-role {\n  color: #235bea;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 18px 0 24px 0;\n}\n\n.st-user-group,\n.st-user-info .st-user-speciality,\n.st-user-info .st-user-curator {\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 12px 0;\n}\n\n.st-user-info .st-user-group strong{\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 12px 0;\n}\n\n.st-user-info .st-user-speciality strong{\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 12px 0;\n}\n\n.st-user-info .st-user-curator strong{\n  color: #002fa7;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 12px 0;\n}\n\n/* Навигация */\n.st-sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.st-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border: none;\n  background: transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.st-nav-item:hover {\n  background: rgba(45, 74, 204, 0.1);\n}\n\n.st-nav-item.active {\n  background: rgba(102, 126, 234, 0.15);\n  font-weight: 600;\n}\n\n.st-nav-text {\n  font-size: 14px;\n  color: #002fa7;\n}\n\n.st-nav-indicator {\n  width: 3px;\n  height: 24px;\n  background: #002fa7;\n  border-radius: 2px;\n  position: absolute;\n  right: -24px;\n}\n\n/* Иконки */\n.st-nav-svg-icon {\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.st-nav-svg-white-icon {\n  width: 36px;\n  height: 36px;\n  margin: 6px 6px 0 4px;\n}\n\n.st-nav-toggle-icon {\n  width: 22px;\n  height: 22px;\n  z-index: 1;\n}\n\n/* Футер */\n.st-sidebar-footer {\n  margin-top: 6px;\n}\n\n.st-quick-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  background: rgba(102, 126, 234, 0.1);\n  padding: 16px;\n  border-radius: 12px;\n}\n\n.st-stat-item {\n  text-align: center;\n  margin: 0;\n}\n\n.st-stat-item .st-stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002fa7;\n  margin: 0;\n}\n\n.st-stat-item .st-stat-label {\n  font-size: 11px;\n  color: #002fa7;\n  margin: 8px 0 0 0;\n}\n\n/* Основная область контента */\n.st-content-area {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  z-index: 3;\n  position: relative;\n}\n\n.st-content-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  flex-wrap: nowrap;\n  min-width: 0;\n  gap: 12px;\n}\n\n.st-content-title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.st-title-icon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.st-content-title {\n  color: white;\n  font-size: 26px;\n  font-weight: 600;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.st-content-subtitle {\n  color: white;\n  font-weight: 200;\n  font-size: 14px;\n  margin: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n}\n\n/* Альтернативный вариант без разделительной линии */\n.st-content-subtitle.without-border {\n  border-left: none;\n  padding-left: 0;\n  margin-left: 8px;\n}\n\n.st-content-card {\n  background: white;\n  border-radius: 20px;\n  padding: 28px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  min-height: 550px;\n  width: 100%;\n  z-index: 1;\n  position: relative;\n}\n\n/* Анимированный фон */\n.st-background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.st-shape {\n  position: absolute;\n  opacity: 0.1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: st-float 20s infinite linear;\n}\n\n.st-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }\n.st-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }\n.st-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }\n\n@keyframes st-float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-20px) rotate(90deg); }\n  50% { transform: translateY(0) rotate(180deg); }\n  75% { transform: translateY(20px) rotate(270deg); }\n}\n\n/* Адаптивность */\n@media (max-width: 1200px) {\n  .st-content {\n    max-width: 95vw;\n    padding: 16px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .st-main {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .st-main.sidebar-collapsed {\n    grid-template-columns: 1fr;\n  }\n  \n  .st-sidebar {\n    order: 2;\n    min-height: auto;\n  }\n  \n  .st-sidebar.collapsed {\n    width: 100%;\n    padding: 20px;\n    flex-direction: row;\n  }\n  \n  .st-sidebar.collapsed .st-sidebar-nav {\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n  }\n  \n  .st-sidebar.collapsed .st-nav-item {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .st-content-area {\n    order: 1;\n  }\n  \n  .st-nav-indicator,\n  .st-sidebar-toggle {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .st-content {\n    padding: 12px;\n  }\n  \n  .st-content-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n  \n  .st-content-title {\n    font-size: 22px;\n    white-space: normal;\n  }\n  \n  .st-content-subtitle {\n    margin-left: 0;\n    font-size: 13px;\n    white-space: normal;\n  }\n  \n  .st-content-card {\n    padding: 16px;\n    min-height: 500px;\n  }\n  \n  .st-quick-stats {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .st-sidebar.collapsed {\n    padding: 16px;\n  }\n  \n  .st-sidebar.collapsed .st-nav-item {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .st-nav-svg-icon {\n    width: 22px;\n    height: 22px;\n  }\n  \n  .st-nav-svg-white-icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n@media (max-width: 480px) {\n  .st-content {\n    padding: 8px;\n  }\n  \n  .st-main {\n    gap: 16px;\n    margin-top: 16px;\n  }\n  \n  .st-sidebar {\n    padding: 16px;\n    border-radius: 16px;\n  }\n  \n  .st-content-card {\n    padding: 12px;\n    border-radius: 16px;\n    min-height: 450px;\n  }\n  \n  .st-user-info .st-user-name,\n  .st-user-patronymic {\n    font-size: 16px;\n  }\n  \n  .st-content-title {\n    font-size: 20px;\n    gap: 8px;\n  }\n  \n  .st-sidebar.collapsed .st-nav-item {\n    width: 44px;\n    height: 44px;\n  }\n  \n  .st-nav-svg-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 360px) {\n  .st-sidebar.collapsed .st-nav-item {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .st-nav-svg-icon {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .st-content-title {\n    font-size: 18px;\n  }\n  \n  .st-content-subtitle {\n    font-size: 12px;\n  }\n}\n\n\n/* Стили для индикатора загрузки */\n.st-loading-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.st-loading-indicator::before {\n  content: '';\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.st-content-title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Стили для иконки переключения */\n.st-nav-toggle-icon.rotated {\n  transform: rotate(180deg);\n}\n\n/* Улучшенные стили для информации о пользователе */\n.st-user-info p {\n  margin: 4px 0;\n  line-height: 1.4;\n}\n\n.st-user-speciality,\n.st-user-profile,\n.st-user-education,\n.st-user-course,\n.st-user-curator {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.st-user-speciality strong,\n.st-user-profile strong,\n.st-user-education strong,\n.st-user-course strong,\n.st-user-curator strong {\n  color: #374151;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Стили для иконок заголовка */\n.st-title-icon {\n  width: 36px;\n  height: 36px;\n  margin-left: 4px;\n  margin-right: 4px;\n  filter: brightness(1);\n}\n\n.st-theme-dark .st-title-icon {\n  filter: brightness(0) invert(1);\n}\n\n.st-theme-light .st-title-icon {\n  filter: none;\n}\n\n.st-content-title-wrapper .st-title-icon {\n  width: 36px;\n  height: 36px;\n}\n\n.st-theme-dark .st-content-title-wrapper .st-title-icon {\n  filter: brightness(0) invert(1);\n}\n\n.st-theme-light .st-content-title-wrapper .st-title-icon {\n  filter: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
